import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Label, Form, Alert, Input, FormFeedback, Spinner } from 'reactstrap';
import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-dark.png";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// Service API - Connexion dynamique au backend Laravel
import { authAPI } from "../../services/api";
import { toast } from 'react-toastify';
import { useAuth } from '../../contexts/AuthContext';

const Login = () => {
  document.title = "Connexion | Ticket Management";

  const navigate = useNavigate();
  const { login: authLogin } = useAuth(); // Utiliser la fonction login du contexte
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Email invalide")
        .required("Veuillez entrer votre email"),
      password: Yup.string()
        .required("Veuillez entrer votre mot de passe"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      setError(null);

      try {
        console.log('📤 Envoi de la requête de connexion...', values.email);

        // Utiliser la fonction login du contexte AuthContext
        const result = await authLogin(values.email, values.password);

        if (result.success) {
          console.log('✅ Connexion réussie via AuthContext');

          // Redirection dynamique selon le rôle
          const user = result.user;
          let targetPath = '/dashboard';

          if (user.role === 'client') {
            targetPath = '/projets';
          } else if (user.role === 'collaborateur') {
            targetPath = '/tickets';
          }

          setTimeout(() => {
            console.log(`➡️ Navigation vers ${targetPath}`);
            navigate(targetPath);
          }, 500);
        } else {
          console.log('❌ Connexion échouée:', result.error);
          setError(result.error || 'Identifiants incorrects');
        }
      } catch (err) {
        console.error('❌ Erreur de connexion:', err);
        const errorMessage = err.response?.data?.message ||
          err.response?.data?.errors?.email?.[0] ||
          'Identifiants incorrects';
        setError(errorMessage);
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
        });
      } finally {
        setLoading(false);
      }
    }
  });

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">

                  <h3 className="text-center mt-5 mb-4">
                    <Link to="/" className="d-block auth-logo">
                      <span style={{ fontSize: "30px", fontWeight: "bold", color: "#7a6fbe" }}>Rakops</span>
                    </Link>
                  </h3>

                  <div className="p-3">
                    <h4 className="text-muted font-size-18 mb-1 text-center">Bienvenue !</h4>
                    <p className="text-muted text-center">Connectez-vous à Ticket Management</p>


                    <Form
                      className="form-horizontal mt-4"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {error && <Alert color="danger">{error}</Alert>}

                      <div className="mb-3">
                        <Label htmlFor="email">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Entrez votre email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                          disabled={loading}
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label htmlFor="password">Mot de passe</Label>
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type="password"
                          placeholder="Entrez votre mot de passe"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.password && validation.errors.password ? true : false
                          }
                          disabled={loading}
                        />
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        ) : null}
                      </div>

                      <Row className="mb-3 mt-4">
                        <div className="col-6">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customControlInline"
                              disabled={loading}
                            />
                            <label className="form-check-label" htmlFor="customControlInline">
                              Se souvenir
                            </label>
                          </div>
                        </div>
                        <div className="col-6 text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <Spinner size="sm" className="me-2" />
                                Connexion...
                              </>
                            ) : (
                              'Connexion'
                            )}
                          </button>
                        </div>
                      </Row>

                      <Row className="form-group mb-0">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock"></i> Mot de passe oublié ?
                        </Link>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-5 text-center">
                <p className="text-muted">
                  © {new Date().getFullYear()} Rakops Solutions. Tous droits réservés. <br /> Construit avec passion.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  )
}

export default Login;
